import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faUpload, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { JWT } from "../../constants/local-storage";
import { functions } from "../../constants/common-functions";

/**
 * Generic Admin Import Screen
 * Driven entirely by importTypes configuration
 */
export default function AdminImportScreen() {
	
	

  /* ----------------------------
   * Import type configuration
   * ---------------------------- */
  const importTypes = [
    {
      id: 1,
	  code:'UTILISATION',
      name: "Utilisation",
      description: "Desk and room utilisation observations",
      restImport: "/resolutionsoftwareplatform/import/utilisation",
      restExport: "/resolutionsoftwareplatform/import/utilisation/template",
      accepts: [".csv", ".xlsx"]
    },
    {
      id: 2,
	  code:'SPACES',
      name: "Spaces",
      description: "Space definitions and attributes",
      restImport: "/resolutionsoftwareplatform/import/space",
      restExport: "/resolutionsoftwareplatform/import/space/template",
      accepts: [".csv", ".xlsx"]
    },
	{
	   id: 3,
	   code: 'ROOM_BOOKINGS',
	   name: "Room Bookings",
	   description: "Room booking schedules (mapped to spaces)",
	   restImport: "/resolutionsoftwareplatform/admin/roombookings/import",
	   restExport: "/resolutionsoftwareplatform/admin/roombookings/export-template",
	   accepts: [".xlsx"] // 👈 keep strict (your format is structured)
	 }
  ];

  /* ----------------------------
   * State
   * ---------------------------- */
  const [selectedImportType, setSelectedImportType] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [statusMessage, setStatusMessage] = useState(null);
  
  const [importRuns, setImportRuns] = useState([]);
  	
  	useEffect(() => {
		let importType = selectedImportType ? selectedImportType.code : '';
		
  	     functions.getArrayFromAjax(
  	       "/resolutionsoftwareplatform/import/utilisation/importruns?importType=" + importType,
  	       setImportRuns,
  	       null
  	     );
  	   
  	 }, [selectedImportType]);

  /* ----------------------------
   * Handlers
   * ---------------------------- */
  function onImportTypeChange(event) {
    const selectedId = parseInt(event.target.value, 10);
    const found = importTypes.find(function (t) {
      return t.id === selectedId;
    });

    setSelectedImportType(found || null);
    setSelectedFile(null);
    setStatusMessage(null);
  }

  function onFileChange(event) {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  }

  function downloadTemplate() {
    if (!selectedImportType) {
      return;
    }

    setStatusMessage("Downloading template…");

    fetch(selectedImportType.restExport, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(JWT)
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Failed to download template");
        }
        return response.blob();
      })
      .then(function (blob) {
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download =
          selectedImportType.name.toLowerCase() + "_import_template.xlsx";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
        setStatusMessage(null);
      })
      .catch(function () {
        setStatusMessage("Error downloading template");
      });
  }

  function validateImport() {
    if (!selectedImportType || !selectedFile) {
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    setStatusMessage("Validating file…");

    fetch(selectedImportType.restImport + "?mode=PREVIEW", {
      method: "POST",
	  headers: {
	     Authorization: "Bearer " + localStorage.getItem(JWT)
	   },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Validation failed");
        }
        return response.json();
      })
      .then(function (data) {
        setStatusMessage(
          "Preview OK: " +
          data.rows +
          " rows, " +
          data.errors +
          " errors"
        );
      })
      .catch(function () {
        setStatusMessage("Error validating import file");
      });
  }

  /* ----------------------------
   * Render
   * ---------------------------- */
  return (
    <div style={{ display: "flex", height: "100vh" }}>
      <LeftMenu />
	  <Header title="Data Import" />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
       

        <div style={{ padding: "20px", marginLeft:'80px', marginTop:'80px' }}>

          {/* Import type selector */}
          <div style={styles.topBar}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <select
                style={styles.select}
                value={selectedImportType ? selectedImportType.id : ""}
                onChange={onImportTypeChange}
              >
                <option value="">Select Import Type</option>
                {importTypes.map(function (type) {
                  return (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  );
                })}
              </select>

              {selectedImportType && (
                <FontAwesomeIcon
                  icon={faInfoCircle}
                  title={selectedImportType.description}
                  style={{ color: "#666" }}
                />
              )}
            </div>
          </div>

          {/* Main panel */}
          {selectedImportType && (
            <div style={styles.mainPanel}>
				<div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom:'20px' }}>
	             <select
	               style={styles.select}
	              
	             >
	               <option value="">Select Import Run</option>
	               {importRuns.map(function (run) {
	                 return (
	                   <option key={run.id} value={run.id}>
	                     {run.title}
	                   </option>
	                 );
	               })}
	             </select>

	           
	           </div>
              {/* Template */}
              <div style={styles.section}>
                <button style={styles.button} onClick={downloadTemplate}>
                  <FontAwesomeIcon icon={faDownload} /> Download Template
                </button>
              </div>

              {/* Upload */}
              <div style={styles.section}>
                <input
                  type="file"
                  accept={selectedImportType.accepts.join(",")}
                  onChange={onFileChange}
                />
              </div>

              {/* Actions */}
              <div style={styles.section}>
                <button
                  style={styles.primaryButton}
                  disabled={!selectedFile}
                  onClick={validateImport}
                >
                  <FontAwesomeIcon icon={faUpload} /> Validate / Preview
                </button>
              </div>

              {/* Status */}
              {statusMessage && (
                <div style={styles.status}>
                  {statusMessage}
                </div>
              )}

            </div>
          )}

        </div>
      </div>
    </div>
  );
}

/* ----------------------------
 * Styles
 * ---------------------------- */
const styles = {
  topBar: {
    marginBottom: "20px",
    display: "flex",
    justifyContent: "space-between"
  },
  select: {
    padding: "8px 12px",
    fontSize: "14px"
  },
  mainPanel: {
    background: "#ffffff",
    borderRadius: "10px",
    border: "1px solid rgba(0,0,0,0.06)",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    padding: "20px",
    maxWidth: "700px"
  },
  section: {
    marginBottom: "15px"
  },
  button: {
    padding: "8px 14px",
    cursor: "pointer"
  },
  primaryButton: {
    padding: "8px 14px",
    background: "#0b5ed7",
    color: "#ffffff",
    border: "none",
    cursor: "pointer"
  },
  status: {
    marginTop: "15px",
    color: "#333"
  }
};